
// ROUTES
require('modules/archive-admin/routes/archive-admin');

// CONTROLLERS
require('modules/archive-admin/controllers/archive-admin');


angular.module('unica_archive_admin', [

	// ROUTES
	'unica_archive_admin.archive_admin_routes',

	// CONTROLLERS
	'unica_archive_admin.archive_admin_controllers',

]);